<template>
  <el-dialog
    title="备注"
    :visible.sync="visible"
    width="380px"
    :append-to-body="true"
    custom-class="att-remark-edit"
  >
    <el-input
      type="textarea"
      :rows="3"
      placeholder="备注"
      v-model="textarea">
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="remarkConfirm" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { RespurceService, Message } from '@/service'

export default {
  data() {
    return {
      visible: false,
      textarea: '',
      resDetail: {},
    }
  },
  methods: {
    open(resDetail = {}) {
      console.log(resDetail);
      this.textarea = resDetail.Remark || '';
      this.resDetail = resDetail;
      this.visible = true;
    },
    close() {
      this.visible = false;
    },

    async remarkConfirm() {
      const { ResID, CompID } = this.resDetail;
      if (!ResID || !CompID) {
        this.$emit('confirm');
        return false;
      }
      const res = await RespurceService.update(ResID, CompID, this.textarea || '');
      if (res) {
        Message.success('修改成功');
        this.$emit('confirm');
        this.close();
      } else {
        Message.error('不可修改');
        this.$emit('confirm');
        this.close();
      }
    }
  },
}
</script>

<style lang="less">
  .att-remark-edit{
    background-color: #ffffff;
    .el-dialog__body{
      padding: 0 12px;
    }
    .el-dialog__header{
      padding: 12px;
      span{
        font-size: 14px;
      }
    }
    .el-dialog__headerbtn{
      top: 16px;
    }
    .el-dialog__footer{
      padding: 12px;
    }
  }
</style>

